import React, { useEffect, useState } from 'react';
import ModuleLayout from './ModuleLayout';
import { ExoTasks } from '../exo/ExoTasks';
import { updateOrCreate } from '../special/updateOrCreate';
import { DBRequest, useConfig } from '../../api/api';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Cookies from 'universal-cookie';
import ExoDialog from '../exo/ExoDialog';
import { NewTask } from '../new/NewTask';
import Pagination from '../special/Pagination';
import Feedback from '../special/Feedback';
import ExoAlert from '../exo/ExoAlert';

const DashboardUserTasks = ({ colSpan, rowSpan, debug }) => {
  const config = useConfig();
  const [tasks, setTasks] = useState(null);
  const { t } = useTranslation();

  const cookies = new Cookies();
  const userId = cookies.get('userId');

  const [openAlert, setOpenAlert] = useState(null);

  // feedback
  const [alertState, setAlertState] = useState({
    alertOpen: false,
    alertType: 'info',
    alertText: 'test',
  });

  function handleFeedback(text, type) {
    setAlertState({ alertOpen: true, alertText: text, alertType: type });
  }

  useEffect(() => {
    // tasks
    loadUserTasks(0);
  }, [config]);
  //&sortBy[eq]=${deadline}&sortOrder[eq]=descending
  function loadUserTasks(status) {
    setTasks(null);
    DBRequest({
      config,
      path: `user-tasks?status[eq]=${status}&userId[eq]=${userId}&sortBy=deadline&sortOrder=asc`,
      onResponse: setTasks,
    });
  }

  // edit
  const [editTask, setEditTask] = useState(null);

  // task change
  function updateTasks(res) {
    const newTasks = updateOrCreate(tasks, res.data);
    setTasks(newTasks);
  }

  return (
    <ModuleLayout
      colSpan={colSpan}
      rowSpan={rowSpan}
      label={`${t('Private To-Do List')} ${
        tasks ? `(${tasks.data.length})` : ''
      }`}
    >
      <Box className="flex flex-col h-full overflow-y-auto">
        <ExoTasks
          tasks={tasks}
          onChange={setTasks}
          isLoading={!Boolean(tasks)}
          noNew
          toggelSx={{ position: 'absolute', top: 6, right: 6 }}
          onEdit={setEditTask}
          onStatusChange={loadUserTasks}
        />
      </Box>
      <ExoDialog
        open={Boolean(editTask)}
        onClose={() => setEditTask(null)}
        limitWidth
      >
        <NewTask
          startData={editTask}
          onClose={() => setEditTask(null)}
          onCreate={updateTasks}
          onChange={updateTasks}
          targetId={tasks?.data.id}
          targetType={'companyLead'}
          onFeedback={handleFeedback}
        />
      </ExoDialog>
      <Feedback state={alertState} setState={setAlertState} />
      <ExoAlert
        open={Boolean(openAlert)}
        alert={openAlert || {}}
        onClose={openAlert?.onCancel}
        onSubmit={openAlert?.onSubmit}
      />

      {tasks && tasks?.meta?.lastPage !== 1 && (
        <Pagination data={tasks} setData={setTasks} isSmall />
      )}
    </ModuleLayout>
  );
};

export default DashboardUserTasks;
